<template>
    <div>
      <p class="aviso-participacao">
          Senhor licitante, caso não queira mais participar de um item ou grupo específico,
          basta clicar no ícone de <strong>“X”</strong> para apagar o valor preenchido.
          Assim, o campo ficará com a palavra <em>“informe”</em>, indicando que você não
          está mais participando daquele item.
      </p>
        <v-data-table
            :headers="headers"
            :items="lotesItensSimularProposta"
            class="az-table-list"
            no-data-text="Não há simulação de proposta disponíveis"
            hide-actions
        >
            <template v-slot:items="props">
                <td>{{ descricaoLoteItem(props.item) }}</td>
                <td class="small-colunm pt-1">
                    <v-tooltip top max-width=750>
                        <span slot="activator">
                            <span class="circulo" v-if="props.item.tipoNegociacao === 'Exclusivo'"><span>E</span></span>
                            <span class="circulo" v-else-if="props.item.tipoNegociacao === 'Diferenciado'"><span>D</span></span>
                            <span class="circulo" v-else><span>S</span></span>
                        </span>
                        <span v-if="props.item.tipoNegociacao === 'Exclusivo'">Exclusivo</span>
                        <span v-else-if="props.item.tipoNegociacao === 'Diferenciado'">Diferenciado</span>
                        <span v-else>Sem Diferenciação</span>
                    </v-tooltip>
                    <v-tooltip top max-width=750>
                        <span slot="activator">
                          {{ props.item.itemCompraDescricao | az-clip-text(50) }}
                        </span>
                        <span>{{props.item.itemCompraDescricao}}</span>
                    </v-tooltip>
                </td>
                <td>{{ props.item.unidade }}</td>
                <td>{{ props.item.quantidade }}</td>
                <td>
                    <v-text-field
                        v-model="props.item.marca"
                        :maxlength="200">
                    </v-text-field>
                </td>
                <td>
                    <v-text-field
                        v-model="props.item.modelo"
                        :maxlength="200">
                    </v-text-field>
                </td>
                <td>
                    <formatador-moeda :valor="props.item.valorUnitarioReferencia"
                                      :casas-decimais="casasDecimais()"></formatador-moeda>
                </td>
                <td v-if="isMaiorDesconto">
                    <campo-moeda v-model="props.item.valorUnitario" :casas-decimais="casasDecimais()"
                                 :id-campo="props.item.licitacaoLoteItemId" :menor-preco="true"></campo-moeda>
                </td>
                <template v-else>
                    <td>
                        <az-money-licitacao
                            v-model="props.item.valorUnitario"
                            prefix=""
                            suffix=""
                            :precision="casasDecimais()"
                            placeholder="Informe"
                            show-clear-button
                            dense
                            class="clear-button"
                            event-submit="change"
                        ></az-money-licitacao>
                    </td>
                    <td>
                        <formatador-moeda :valor="valorTotalItem(props.item.valorUnitario, props.item.quantidade)"
                                          :casas-decimais="casasDecimais()"></formatador-moeda>
                    </td>
                </template>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { tiposLicitacao } from '@/core/constants'
import accounting from 'accounting'
import FormatadorMoeda from '@/views/components/FormatadorMoeda'
import CampoMoeda from '@/views/components/CampoMoeda'
import AzMoneyLicitacao from '@/views/components/AzMoneyLicitacao'

export default {
    name: 'SimularPropostaTabela',
    components: { CampoMoeda, FormatadorMoeda, AzMoneyLicitacao },
    props:{
        lotesItensSimularProposta: {
            type: Array,
            default: () => []
        },
        licitacao: {
            type: Object,
            required: true
        }
    },
    computed: {
        headers() {
            if (this.isMaiorDesconto) {
                return [
                    { text: 'Tipo', sortable: false, width: '10%', class: 'primary--text'},
                    { text: 'Descrição', sortable: false, width: '20%', class: 'primary--text'},
                    { text: 'Unidade', sortable: false, width: '4%', class: 'primary--text'},
                    { text: 'Qtd.', sortable: false, width: '3%', class: 'primary--text'},
                    { text: 'Marca', sortable: false, width: '7%', class: 'primary--text'},
                    { text: 'Modelo', sortable: false, width: '7%', class: 'primary--text'},
                    { text: 'Val. Ref. Unit.', sortable: false, width: '5%', class: 'primary--text'},
                    { text: 'Desconto (%)', sortable: false, width: '7%', class: 'primary--text'}
                ]
            } else {
                return [
                    {text: 'Tipo', sortable: false, width: '10%', class: 'primary--text'},
                    {text: 'Descrição', sortable: false, width: '20%', class: 'primary--text'},
                    {text: 'Unidade', sortable: false, width: '4%', class: 'primary--text'},
                    {text: 'Qtd.', sortable: false, width: '3%', class: 'primary--text'},
                    {text: 'Marca', sortable: false, width: '7%', class: 'primary--text'},
                    {text: 'Modelo', sortable: false, width: '7%', class: 'primary--text'},
                    {text: 'Val. Ref. Unit.', sortable: false, width: '5%', class: 'primary--text'},
                    {text: 'Valor', sortable: false, width: '7%', class: 'primary--text'},
                    {text: 'Total', sortable: false, width: '7%', class: 'primary--text'}
                ]
            }
        },
        isMenorPreco() {
            return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MP
        },
        isMaiorDesconto() {
            return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MD
        },
    },
    methods: {
        descricaoLoteItem(item) {
            return item.loteDescricao + '/' + item.itemCompraCodigo
        },
        valorTotalItem(valorUnitario, quantidade) {
            const preco = accounting.unformat(valorUnitario, ',')
            return preco * quantidade
        },
        casasDecimais() {
            return this.licitacao && this.licitacao.casasDecimais ? this.licitacao.casasDecimais : 2
        }
    }
}
</script>

<style lang="stylus">
    .circulo {
        width: 1.8em
        height: 1.8em
        border-radius: 50%
        background-color: #bbb
        display: inline-flex
        justify-content: center
        align-items: center
        font-size: 12px
        font-weight: bold
        color: white
    }
    .circulo span {
        text-align: center
        line-height: 20px
    }
    .aviso-participacao {
        font-size: 1rem;
        line-height: 1.5;
        margin-top: 1rem;
        margin-bottom: 16px;
        color: #555;
    }
</style>